import React, { useState } from "react";
import MDBox from "components/MDBox";
import { Card, Tab, Tabs } from "@mui/material";
import GerarRemessa from "./tabs/GerarRemessa";
import ImportarRetorno from "./tabs/ImportarRetorno";

function CnabSystem() {
    const [tabValue, setTabValue] = useState(0);

    const handleSetTabValue = (event, newValue) => setTabValue(newValue);

    return (
        <Card id="cnab-info">
            <MDBox sx={{ width: '100%', px: 3, mb: 3, pt: 2 }}>
                <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleSetTabValue} aria-label="cnab tabs">
                        <Tab label="Gerar Remessa" sx={{ fontSize: 12 }} />
                        <Tab label="Importar Retorno" sx={{ fontSize: 12 }} />
                    </Tabs>
                </MDBox>
            </MDBox>
            
            <MDBox px={3} pb={3}>
                <div role="tabpanel" hidden={tabValue !== 0}>
                    {tabValue === 0 && <GerarRemessa />}
                </div>
                <div role="tabpanel" hidden={tabValue !== 1}>
                    {tabValue === 1 && <ImportarRetorno />}
                </div>
            </MDBox>
        </Card>
    );
}

export default CnabSystem;
